import SidemenuItem from "./SidemenuItem";
import PropTypes from "prop-types";
import { StyledSidemenu } from "../../styles/StyledSidemenu";
import { useAppContext } from "../../context/appContext";

const defaultMenuItems = [
	{ name: "Decisions", path: "/decisions" },
	{ name: "People", path: "/people" },
	{ name: "Units", path: "/units" },
	{ name: "Meetings", path: "/meetings" },
	{ name: "Calendar", path: "/calendar" },
	{ name: "Your Library", path: "/people" }, //Temporary set to people since also under construction
];

const defaultAdminMenuItems = defaultMenuItems.concat([{ name: "Admin panel", path: "/admin-panel" }]);

export const Sidemenu = ({ items }) => {
	const {
		items: { isAdmin },
	} = useAppContext();

	const menuItems = Array.isArray(items)
		? items.map((item, index) => <SidemenuItem key={index} item={item}></SidemenuItem>)
		: isAdmin
			? defaultAdminMenuItems.map((item, index) => <SidemenuItem key={index} item={item}></SidemenuItem>)
			: defaultMenuItems.map((item, index) => <SidemenuItem key={index} item={item}></SidemenuItem>);

	if (menuItems.length < 1) return <></>;

	return (
		<StyledSidemenu>
			<ul>{menuItems}</ul>
		</StyledSidemenu>
	);
};

Sidemenu.propTypes = {
	items: PropTypes.array,
};
